(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@zilliqa-js/core'), require('@zilliqa-js/crypto'), require('@zilliqa-js/util'), require('@zilliqa-js/account')) :
    typeof define === 'function' && define.amd ? define(['exports', '@zilliqa-js/core', '@zilliqa-js/crypto', '@zilliqa-js/util', '@zilliqa-js/account'], factory) :
    (factory((global.zjsBlockchain = {}),global['@zilliqa-js/core'],global['@zilliqa-js/crypto'],global['@zilliqa-js/util'],global['@zilliqa-js/account']));
}(this, (function (exports,core,crypto,util,account) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    //  Copyright (C) 2018 Zilliqa
    function toTxParams(response) {
        var _a = response.result, toAddr = _a.toAddr, senderPubKey = _a.senderPubKey, gasPrice = _a.gasPrice, gasLimit = _a.gasLimit, nonce = _a.nonce, amount = _a.amount, receipt = _a.receipt, version = _a.version, code = _a.code, data = _a.data, rest = __rest(_a, ["toAddr", "senderPubKey", "gasPrice", "gasLimit", "nonce", "amount", "receipt", "version", "code", "data"]);
        var msg = receipt.errors
            ? Object.keys(receipt.errors).reduce(function (acc, depth) {
                var _a;
                var errorMsgList = receipt.errors[depth].map(function (num) { return core.TransactionError[num]; });
                return __assign(__assign({}, acc), (_a = {}, _a[depth] = errorMsgList, _a));
            }, {})
            : {};
        return __assign(__assign({}, rest), { version: parseInt(version, 10), toAddr: crypto.toChecksumAddress(toAddr), pubKey: senderPubKey.replace('0x', ''), gasPrice: new util.BN(gasPrice), gasLimit: util.Long.fromString(gasLimit, 10), amount: new util.BN(amount), nonce: parseInt(nonce, 10), code: code,
            data: data, receipt: __assign(__assign({}, receipt), { accepted: receipt.accepted, errors: msg, cumulative_gas: parseInt(receipt.cumulative_gas, 10) }) });
    }

    //  Copyright (C) 2018 Zilliqa
    var Blockchain = /** @class */ (function () {
        function Blockchain(provider, signer) {
            this.pendingErrorMap = {
                0: 'Not Present - Txn was already processed and confirmed or Txn does not exist',
                1: 'Pending - nonce too high',
                2: 'Pending - blk gas limit exceeded',
                3: 'Pending - consensus failure',
                10: 'Dropped - math error',
                11: 'Dropped - scilla invocation error',
                12: 'Dropped - account init error',
                13: 'Dropped - invalid source account',
                14: 'Dropped - gas limit too high',
                15: 'Dropped - txn type unknown',
                16: 'Dropped - txn in wrong shard',
                17: 'Dropped - account in wrong shard',
                18: 'Dropped - code size too large',
                19: 'Dropped - txn verification error',
                20: 'Dropped - gas limit too low',
                21: 'Dropped - insuff balance',
                22: 'Dropped - insuff gas for checker',
                23: 'Dropped - duplicate txn found',
                24: 'Dropped - txn w/ higher gas found',
                25: 'Dropped - invalid dest account',
                26: 'Dropped - state addition error',
                27: 'Dropped - Txn has lower nonce than expected',
                255: 'Error - Internal database error',
            };
            this.transactionStatusMap = {
                0: { 0: 'Transaction not found', 1: ' Pending - Dispatched' },
                1: {
                    2: 'Pending - Soft-confirmed (awaiting Tx block generation)',
                    4: 'Pending - Nonce is higher than expected',
                    5: 'Pending - Microblock gas limit exceeded',
                    6: 'Pending - Consensus failure in network',
                },
                2: {
                    3: 'Confirmed',
                    10: 'Rejected - Transaction caused math error',
                    11: 'Rejected - Scilla invocation error',
                    12: 'Rejected - Contract account initialization error',
                    13: 'Rejected - Invalid source account',
                    14: 'Rejected - Gas limit higher than shard gas limit',
                    15: 'Rejected - Unknown transaction type',
                    16: 'Rejected - Transaction sent to wrong shard',
                    17: 'Rejected - Contract & source account cross-shard issue',
                    18: 'Rejected - Code size exceeded limit',
                    19: 'Rejected - Transaction verification failed',
                    20: 'Rejected - Gas limit too low',
                    21: 'Rejected - Insufficient balance',
                    22: 'Rejected - Insufficient gas to invoke Scilla checker',
                    23: 'Rejected - Duplicate transaction exists',
                    24: 'Rejected - Transaction with higher gas price exists',
                    25: 'Rejected - Invalid destination address',
                    26: 'Rejected - Failed to add contract account to state',
                    27: 'Rejected - Nonce is lower than expected',
                    255: 'Rejected - Internal error',
                },
            };
            this.provider = provider;
            this.provider.middleware.request.use(account.util.formatOutgoingTx, core.RPCMethod.CreateTransaction);
            this.signer = signer;
        }
        /**
         * getBlockChainInfo
         *
         * @returns {Promise<RPCResponse<BlockchainInfo, string>>}
         */
        Blockchain.prototype.getBlockChainInfo = function () {
            return this.provider.send(core.RPCMethod.GetBlockchainInfo);
        };
        /**
         * getShardingStructure
         *
         * @returns {Promise<RPCResponse<ShardingStructure, string>>}
         */
        Blockchain.prototype.getShardingStructure = function () {
            return this.provider.send(core.RPCMethod.GetShardingStructure);
        };
        /**
         * getDSBlock
         *
         * Get details of a Directory Service block by block number.
         *
         * @param {number} blockNum
         * @returns {Promise<RPCResponse<DsBlockObj, string>>}
         */
        Blockchain.prototype.getDSBlock = function (blockNum) {
            return this.provider.send(core.RPCMethod.GetDSBlock, blockNum.toString());
        };
        /**
         * getLatestDSBlock
         *
         * Get details of the most recent Directory Service block.
         *
         * @returns {Promise<RPCResponse<DsBlockObj, string>>}
         */
        Blockchain.prototype.getLatestDSBlock = function () {
            return this.provider.send(core.RPCMethod.GetLatestDSBlock);
        };
        /**
         * getNumDSBlocks
         *
         * Gets the number of DS blocks that the network has processed.
         *
         * @returns {Promise<RPCResponse<string, string>>}
         */
        Blockchain.prototype.getNumDSBlocks = function () {
            return this.provider.send(core.RPCMethod.GetNumDSBlocks);
        };
        /**
         * getDSBlockRate
         *
         * Gets the average rate of DS blocks processed per second
         *
         * @returns {Promise<RPCResponse<number, string>>}
         */
        Blockchain.prototype.getDSBlockRate = function () {
            return this.provider.send(core.RPCMethod.GetDSBlockRate);
        };
        /**
         * getDSBlockListing
         *
         * Get a paginated list of Directory Service blocks. Pass in page number as
         * parameter. Returns a maxPages variable that specifies the max number of
         * pages. 1 - latest blocks, maxPages - oldest blocks.
         *
         * @param {number} max
         * @returns {Promise<RPCResponse<BlockList, string>>}
         */
        Blockchain.prototype.getDSBlockListing = function (max) {
            return this.provider.send(core.RPCMethod.DSBlockListing, max);
        };
        /**
         * getTxBlock
         *
         * Get details of a Transaction block by block number.
         *
         * @param {number} blockNum
         * @returns {Promise<RPCResponse<TxBlockObj, string>>}
         */
        Blockchain.prototype.getTxBlock = function (blockNum) {
            return this.provider.send(core.RPCMethod.GetTxBlock, blockNum.toString());
        };
        /**
         * getLatestTxBlock
         *
         * Get details of the most recent Transaction block.
         *
         * @returns {Promise<RPCResponse<TxBlockObj, string>>}
         */
        Blockchain.prototype.getLatestTxBlock = function () {
            return this.provider.send(core.RPCMethod.GetLatestTxBlock);
        };
        /**
         * getNumTxBlocks
         *
         * Gets the total number of TxBlocks.
         *
         * @returns {Promise<RPCResponse<string, string>>}
         */
        Blockchain.prototype.getNumTxBlocks = function () {
            return this.provider.send(core.RPCMethod.GetNumTxBlocks);
        };
        /**
         * getTxBlockRate
         *
         * Gets the average number of Tx blocks per second.
         *
         * @returns {Promise<RPCResponse<number, string>>}
         */
        Blockchain.prototype.getTxBlockRate = function () {
            return this.provider.send(core.RPCMethod.GetTxBlockRate);
        };
        /**
         * getTxBlockListing
         *
         * Get a paginated list of Transaction blocks. Takes a page number as
         * parameter, where each page contains a list of 10 blocks (max). Returns
         * a maxPages variable that specifies the max number of pages. 1 - latest
         * blocks, maxPages - oldest blocks.
         *
         * @param {number} max
         * @returns {Promise<RPCResponse<BlockList, string>>}
         */
        Blockchain.prototype.getTxBlockListing = function (max) {
            return this.provider.send(core.RPCMethod.TxBlockListing, max);
        };
        /**
         * getNumTransactions
         *
         * Gets the number of transactions processed by the network so far.
         *
         * @returns {Promise<RPCResponse<string, string>>}
         */
        Blockchain.prototype.getNumTransactions = function () {
            return this.provider.send(core.RPCMethod.GetNumTransactions);
        };
        /**
         * getTransactionRate
         *
         * Gets the number of transactions processed per second
         *
         * @returns {Promise<RPCResponse<number, string>>}
         */
        Blockchain.prototype.getTransactionRate = function () {
            return this.provider.send(core.RPCMethod.GetTransactionRate);
        };
        /**
         * getCurrentMiniEpoch
         *
         * Gets the current Tx Epoch.
         *
         * @returns {Promise<RPCResponse<string, string>>}
         */
        Blockchain.prototype.getCurrentMiniEpoch = function () {
            return this.provider.send(core.RPCMethod.GetCurrentMiniEpoch);
        };
        /**
         * getCurrentDSEpoch
         *
         * Gets the current DS Epoch.
         *
         * @returns {Promise<RPCResponse<any, string>>}
         */
        Blockchain.prototype.getCurrentDSEpoch = function () {
            return this.provider.send(core.RPCMethod.GetCurrentDSEpoch);
        };
        /**
         * getPrevDifficulty
         *
         * Gets shard difficulty for previous PoW round
         *
         * @returns {Promise<RPCResponse<number, string>>}
         */
        Blockchain.prototype.getPrevDifficulty = function () {
            return this.provider.send(core.RPCMethod.GetPrevDifficulty);
        };
        /**
         * getPrevDSDifficulty
         *
         * Gets DS difficulty for previous PoW round
         *
         * @returns {Promise<RPCResponse<number, string>>}
         */
        Blockchain.prototype.getPrevDSDifficulty = function () {
            return this.provider.send(core.RPCMethod.GetPrevDSDifficulty);
        };
        /**
         * getTotalCoinSupply
         *
         * Returns the total supply (ZIL) of coins in the network.
         */
        Blockchain.prototype.getTotalCoinSupply = function () {
            return this.provider.send(core.RPCMethod.GetTotalCoinSupply);
        };
        /**
         * getMinerInfo
         *
         * Returns the mining nodes (i.e., the members of the DS committee and shards) at the specified DS block.
         *
         * Notes:
         * 1. Nodes owned by Zilliqa Research are omitted.
         * 2. dscommittee has no size field since the DS committee size is fixed for a given chain.
         * 3. For the Zilliqa Mainnet, this API is only available from DS block 5500 onwards.
         *
         */
        Blockchain.prototype.getMinerInfo = function (dsBlockNumber) {
            return this.provider.send(core.RPCMethod.GetMinerInfo, dsBlockNumber);
        };
        /**
         * createTransaction
         *
         * Creates a transaction and polls the lookup node for a transaction
         * receipt. The transaction is considered to be lost if it is not confirmed
         * within the timeout period.
         *
         * @param {Transaction} tx
         * @param {number} maxAttempts - (optional) number of times to poll before timing out
         * @param {number} number - (optional) interval in ms
         * @returns {Promise<Transaction>} - the Transaction that has been signed and
         * broadcasted to the network.
         */
        Blockchain.prototype.createTransaction = function (tx, maxAttempts, interval, blockConfirm) {
            if (maxAttempts === void 0) { maxAttempts = core.GET_TX_ATTEMPTS; }
            if (interval === void 0) { interval = 1000; }
            if (blockConfirm === void 0) { blockConfirm = false; }
            return __awaiter(this, void 0, void 0, function () {
                var response, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.provider.send(core.RPCMethod.CreateTransaction, __assign(__assign({}, tx.txParams), { priority: tx.toDS }))];
                        case 1:
                            response = _a.sent();
                            if (response.error) {
                                throw response.error;
                            }
                            if (blockConfirm) {
                                return [2 /*return*/, tx.blockConfirm(response.result.TranID, maxAttempts, interval)];
                            }
                            return [2 /*return*/, tx.confirm(response.result.TranID, maxAttempts, interval)];
                        case 2:
                            err_1 = _a.sent();
                            throw err_1;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * createTransactionRaw
         *
         * Create a transaction by using a exist signed transaction payload
         * This payload may come form some offline signing software like ledger
         * Currently we haven't supported convert a singed transaction back to transaction param, so we won't perform
         * confirm logic here, but there is another convenient way to do so, can refer examples/createTransactionRaw.js
         *
         * @param payload
         */
        Blockchain.prototype.createTransactionRaw = function (payload) {
            return __awaiter(this, void 0, void 0, function () {
                var tx, response, err_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            tx = JSON.parse(payload);
                            return [4 /*yield*/, this.provider.send(core.RPCMethod.CreateTransaction, tx)];
                        case 1:
                            response = _a.sent();
                            if (response.error) {
                                throw response.error;
                            }
                            return [2 /*return*/, response.result.TranID];
                        case 2:
                            err_2 = _a.sent();
                            throw err_2;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        Blockchain.prototype.createTransactionWithoutConfirm = function (tx) {
            return __awaiter(this, void 0, void 0, function () {
                var response, err_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.provider.send(core.RPCMethod.CreateTransaction, __assign(__assign({}, tx.txParams), { priority: tx.toDS }))];
                        case 1:
                            response = _a.sent();
                            if (response.error) {
                                throw response.error;
                            }
                            tx.id = response.result.TranID;
                            return [2 /*return*/, tx];
                        case 2:
                            err_3 = _a.sent();
                            throw err_3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * getTransaction
         *
         * Retrieves a transaction from the blockchain by its hash. If the result
         * contains an Error, a rejected Promise is returned with the erorr message.
         * If it does not contained an error, but `receipt.success` is `false`, then
         * a rejected Transaction instance is returned.
         *
         * @param {string} txHash
         * @returns {Promise<Transaction>}
         */
        Blockchain.prototype.getTransaction = function (txHash) {
            return __awaiter(this, void 0, void 0, function () {
                var response, err_4;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.provider.send(core.RPCMethod.GetTransaction, txHash)];
                        case 1:
                            response = _a.sent();
                            if (response.error) {
                                return [2 /*return*/, Promise.reject(response.error)];
                            }
                            return [2 /*return*/, response.result.receipt.success
                                    ? account.Transaction.confirm(toTxParams(response), this.provider)
                                    : account.Transaction.reject(toTxParams(response), this.provider)];
                        case 2:
                            err_4 = _a.sent();
                            throw err_4;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * Returns the status of a specified transaction.
         * This API is available from Zilliqa `V7.0.0` onwards and supports all transaction statuses
         * (unconfirmed, confirmed, and rejected).
         *
         * @param txHash
         * @returns {Promise<TransactionStatusObj>}
         */
        Blockchain.prototype.getTransactionStatus = function (txHash) {
            return __awaiter(this, void 0, void 0, function () {
                var response, modificationState, status_1, err_5;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.provider.send(core.RPCMethod.GetTransactionStatus, txHash)];
                        case 1:
                            response = _a.sent();
                            if (response.error) {
                                return [2 /*return*/, Promise.reject(response.error)];
                            }
                            modificationState = response.result.modificationState;
                            status_1 = response.result.status;
                            response.result.statusMessage = this.transactionStatusMap[modificationState][status_1];
                            return [2 /*return*/, response.result];
                        case 2:
                            err_5 = _a.sent();
                            throw err_5;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * getRecentTransactions
         *
         * Gets a list of recent transactions
         *
         * @returns {Promise<RPCResponse<TxList, never>>}
         */
        Blockchain.prototype.getRecentTransactions = function () {
            return this.provider.send(core.RPCMethod.GetRecentTransactions);
        };
        /**
         * getTransactionsForTxBlock
         *
         * Gets all transactions for a given TxBlock, grouped by shard id
         *
         * @param {number} txBlock
         * @returns {Promise<RPCResponse<string[][], string>>}
         */
        Blockchain.prototype.getTransactionsForTxBlock = function (txBlock) {
            return this.provider.send(core.RPCMethod.GetTransactionsForTxBlock, txBlock.toString());
        };
        /**
         * getTxnBodiesForTxBlock
         *
         * @param {number} txBlock
         * @returns { romise<RPCResponse<TransactionObj[], string>>}
         */
        Blockchain.prototype.getTxnBodiesForTxBlock = function (txBlock) {
            return this.provider.send(core.RPCMethod.GetTxnBodiesForTxBlock, txBlock.toString());
        };
        /**
         * getNumTxnsTxEpoch
         *
         * Gets the number of transactions procesed for a given Tx Epoch.
         *
         * @param {number} epoch
         * @returns {Promise<RPCResponse<number, never>>}
         */
        Blockchain.prototype.getNumTxnsTxEpoch = function (epoch) {
            return this.provider.send(core.RPCMethod.GetNumTxnsTxEpoch, epoch);
        };
        /**
         * getNumTxnsDSEpoch
         *
         * Gets the number of transactions procesed for a given DS Epoch.
         *
         * @param {number} epoch
         * @returns {Promise<any>}
         */
        Blockchain.prototype.getNumTxnsDSEpoch = function (epoch) {
            return this.provider.send(core.RPCMethod.GetNumTxnsDSEpoch, epoch);
        };
        /**
         * getMinimumGasPrice
         *
         * Gets the numeric minimum gas price
         *
         * @returns {Promise<RPCResponse<string, string>>}
         */
        Blockchain.prototype.getMinimumGasPrice = function () {
            return this.provider.send(core.RPCMethod.GetMinimumGasPrice);
        };
        /**
         * getPendingTxn
         * See the pending status of transaction
         * @param txId
         */
        Blockchain.prototype.getPendingTxn = function (txId) {
            return __awaiter(this, void 0, void 0, function () {
                var response, err_6;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.provider.send(core.RPCMethod.GetPendingTxn, txId.replace('0x', '').toLowerCase())];
                        case 1:
                            response = _a.sent();
                            if (response.error) {
                                return [2 /*return*/, Promise.reject(response.error)];
                            }
                            response.result.info = this.pendingErrorMap[response.result.code];
                            return [2 /*return*/, response.result];
                        case 2:
                            err_6 = _a.sent();
                            throw err_6;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * getPendingTxns
         *
         * Returns the pending status of all unvalidated Transactions.
         *
         */
        Blockchain.prototype.getPendingTxns = function () {
            return __awaiter(this, void 0, void 0, function () {
                var response, err_7;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.provider.send(core.RPCMethod.GetPendingTxns)];
                        case 1:
                            response = _a.sent();
                            if (response.error) {
                                return [2 /*return*/, Promise.reject(response.error)];
                            }
                            if (response.result.Txns.length) {
                                response.result.Txns.forEach(function (txn) {
                                    txn.info = _this.pendingErrorMap[txn.code];
                                });
                            }
                            return [2 /*return*/, response.result];
                        case 2:
                            err_7 = _a.sent();
                            throw err_7;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * getBalance
         *
         * Gets the balance of an account by address
         *
         * @param {string} address
         * @returns {Promise<RPCResponse<any, string>>}
         */
        Blockchain.prototype.getBalance = function (addr) {
            var address = util.validation.isBech32(addr) ? crypto.fromBech32Address(addr) : addr;
            return this.provider.send(core.RPCMethod.GetBalance, address.replace('0x', '').toLowerCase());
        };
        /**
         * getSmartContractCode - returns the smart contract code of a deployed contract.
         *
         * @param {string} address
         * @returns {Promise<RPCResponse<{code: string }, string>>}
         */
        Blockchain.prototype.getSmartContractCode = function (addr) {
            var address = util.validation.isBech32(addr) ? crypto.fromBech32Address(addr) : addr;
            return this.provider.send(core.RPCMethod.GetSmartContractCode, address.replace('0x', '').toLowerCase());
        };
        /**
         * getSmartContractInit
         *
         * @param {string} address
         * @returns {Promise<RPCResponse<Value[], string>>}
         */
        Blockchain.prototype.getSmartContractInit = function (addr) {
            var address = util.validation.isBech32(addr) ? crypto.fromBech32Address(addr) : addr;
            return this.provider.send(core.RPCMethod.GetSmartContractInit, address.replace('0x', '').toLowerCase());
        };
        /**
         * getSmartContractState - retrieves the entire state of a smart contract
         *
         * @param {string} address
         * @returns {Promise<RPCResponse<any, string>>}
         */
        Blockchain.prototype.getSmartContractState = function (addr) {
            var address = util.validation.isBech32(addr) ? crypto.fromBech32Address(addr) : addr;
            return this.provider.send(core.RPCMethod.GetSmartContractState, address.replace('0x', '').toLowerCase());
        };
        /**
         * getSmartContractSubState - Queries the contract state, filtered by the variable names.
         * This function is the filtered version of `getSmartContractState`.
         * As `getSubState` performs the filtering, `variableName` of a field is required.
         * If the `subState` is not found, this returns a `null` response.
         *
         * @param {string} address
         * @param { string } variableName - variable name within the state
         * @param { string[] } indices - (optional) If the variable is of map type, you can specify an index (or indices)
         * @returns {Promise<RPCResponse<any, string>>}
         */
        Blockchain.prototype.getSmartContractSubState = function (addr, variableName, indices) {
            var address = util.validation.isBech32(addr) ? crypto.fromBech32Address(addr) : addr;
            if (!variableName) {
                throw new Error('Variable name required');
            }
            return this.provider.send(core.RPCMethod.GetSmartContractSubState, address.replace('0x', '').toLowerCase(), variableName, indices === undefined ? [] : indices);
        };
        /**
         * getSmartContracts
         *
         * @param {string} address
         * @returns {Promise<RPCResponse<ContractObj[], string>>}
         */
        Blockchain.prototype.getSmartContracts = function (addr) {
            var address = util.validation.isBech32(addr) ? crypto.fromBech32Address(addr) : addr;
            return this.provider.send(core.RPCMethod.GetSmartContracts, address.replace('0x', '').toLowerCase());
        };
        /**
         * getContractAddressFromTransactionID
         *
         * @param {string} txHash
         * @returns {Promise<RPCResponse<string, string>>}
         */
        Blockchain.prototype.getContractAddressFromTransactionID = function (txHash) {
            return this.provider.send(core.RPCMethod.GetContractAddressFromTransactionID, txHash);
        };
        __decorate([
            core.sign,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [account.Transaction, Number, Number, Boolean]),
            __metadata("design:returntype", Promise)
        ], Blockchain.prototype, "createTransaction", null);
        __decorate([
            core.sign,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [account.Transaction]),
            __metadata("design:returntype", Promise)
        ], Blockchain.prototype, "createTransactionWithoutConfirm", null);
        return Blockchain;
    }());

    //  Copyright (C) 2018 Zilliqa
    //
    //  This file is part of Zilliqa-Javascript-Library.
    //
    //  This program is free software: you can redistribute it and/or modify
    //  it under the terms of the GNU General Public License as published by
    //  the Free Software Foundation, either version 3 of the License, or
    //  (at your option) any later version.
    //
    //  This program is distributed in the hope that it will be useful,
    //  but WITHOUT ANY WARRANTY; without even the implied warranty of
    //  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    //  GNU General Public License for more details.
    //
    //  You should have received a copy of the GNU General Public License
    //  along with this program.  If not, see <https://www.gnu.org/licenses/>.
    var NetworkMethods;
    (function (NetworkMethods) {
        NetworkMethods["GetClientVersion"] = "GetClientVersion";
        NetworkMethods["GetNetworkId"] = "GetNetworkId";
        NetworkMethods["GetProtocolVersion"] = "GetProtocolVersion";
    })(NetworkMethods || (NetworkMethods = {}));
    var Network = /** @class */ (function () {
        function Network(provider, signer) {
            this.provider = provider;
            this.signer = signer;
        }
        Network.prototype.getClientVersion = function () {
            return this.provider.send("GetClientVersion" /* GetClientVersion */);
        };
        Network.prototype.GetNetworkId = function () {
            return this.provider.send("GetNetworkId" /* GetNetworkId */);
        };
        Network.prototype.GetProtocolVersion = function (blockNum) {
            return this.provider.send("GetProtocolVersion" /* GetProtocolVersion */);
        };
        return Network;
    }());

    //  Copyright (C) 2018 Zilliqa

    exports.Blockchain = Blockchain;
    exports.Network = Network;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.umd.js.map
